import styled, { css } from 'styled-components';

import { Container } from '../Container';
import type { GridContainerProps } from './GridContainer.types';

const gridContainer = {
  looseSm: {
    columnGap: '8px',
  },
  tightSm: {
    columnGap: '8px',
  },
  looseMd: {
    columnGap: '16px',
  },
  tightMd: {
    columnGap: '16px',
  },
  looseLg: {
    columnGap: '24px',
  },
  tightLg: {
    columnGap: '24px',
  },
  looseXl: {
    columnGap: '24px',
  },
  tightXl: {
    columnGap: '24px',
  },
};

export const GridContainerRoot = styled(Container)<GridContainerProps>(
  ({ templateColumns, templateRows, theme: { mediaQueries, breakpoints }, variant }) => css<GridContainerProps>`
    box-sizing: border-box;
    display: grid;
    justify-content: start;
    list-style-type: none;
    padding-top: 0;
    grid-column-gap: ${variant === 'loose' ? gridContainer.looseSm.columnGap : gridContainer.tightSm.columnGap};
    grid-template-columns: repeat(${templateColumns}, 1fr);
    grid-template-rows: ${templateRows === 0 ? 'none' : `repeat(${templateRows}, 1fr`};

    ${mediaQueries.m} {
      grid-column-gap: ${variant === 'loose' ? gridContainer.looseMd.columnGap : gridContainer.tightMd.columnGap};
    }

    ${mediaQueries.l} {
      grid-column-gap: ${variant === 'loose' ? gridContainer.looseLg.columnGap : gridContainer.tightLg.columnGap};
    }

    ${mediaQueries.xl} {
      grid-column-gap: ${variant === 'loose' ? gridContainer.looseXl.columnGap : gridContainer.tightXl.columnGap};
    }
  `
);
